import { useEffect } from 'react';
import { useLocalCurrencyContext } from 'src/providers';

export const useLocalCurrencyTab = ({ tabs, setActiveTabIndex }) => {
  const localCurrency = useLocalCurrencyContext();

  useEffect(() => {
    if (!localCurrency) return;

    const index = tabs.findIndex(tab => tab.label === localCurrency);
    if (index === -1) return;

    setActiveTabIndex(index);
  }, [tabs, setActiveTabIndex, localCurrency]);
};
